import axios from '@/utils/request'
import * as common from '@/api/common'

const ApiUrl = '/admin_api/v1/order/id_card'
export function getList(params) {
  return axios.get(`${ApiUrl}/`, {
    params
  })
}

export function exportCards() {
  return common.baseURL() + '/admin_api/v1/order/id_card/import/'
}

export function del(id) {
  return axios.delete(`${ApiUrl}/${id}/`)
}
export function delAll() {
  return axios.delete(`${ApiUrl}/delete_all/`)
}
